var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i',{class:[
    'dp-icon',
    'fa-fw',
    _vm.iconName,
    _vm.iconStyle,
    _vm.iconAnimation,
    _vm.iconSize,
    {
      'dp-icon--faded': _vm.faded,
    } ],style:(_vm.styles),attrs:{"aria-hidden":"true","tabindex":"-1"}})}
var staticRenderFns = []

export { render, staticRenderFns }